(function () {
    'use strict';

    angular
        .module('app.core')
        .decorator('tmhDynamicLocale', tmhDynamicLocaleDecorator);

    tmhDynamicLocaleDecorator.$inject = ['$delegate', '$q', '$locale', 'tmhDynamicLocaleCache'];
    function tmhDynamicLocaleDecorator($delegate, $q, $locale, tmhDynamicLocaleCache) {
        var originalSet = $delegate.set;

        initialize();
        $delegate.set = set;
        $delegate.loadLanguage = loadLanguage;
        return $delegate;

        //////////////////////////////////////////
        function initialize() {
            var locale = angular.copy($locale);
            tmhDynamicLocaleCache.put(locale.id, locale);
            $delegate.set(locale.id);
        }

        function set(value) {
            return originalSet.call(this, normalize(value));
        }

        function loadLanguage(lang) {
            var lang = normalize(lang),
                isLoaded = !!tmhDynamicLocaleCache.get(lang);

            return isLoaded ? $q.resolve() : loadRemote(lang);
        }

        // Helpers
        function loadRemote(lang) {
            var current = $delegate.get();
            return $delegate.set(lang).finally(reset);

            function reset() {
                $delegate.set(current);
            }
        }
        function normalize(lang) {
            return lang.toLowerCase();
        }
    }

})();
